import React from 'react';
import * as PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { useSelector } from 'react-redux';

import { VideoInfo } from './video-info';
import { VideoPlaceholder } from './video-placeholder';
import { getRatingFeatureSelector } from 'common/selectors';
import { getVideoBoxUISelector, getVideoSelector } from 'components/video-box/selectors';
import { useThumbnailUrl } from 'components/video-generating/use-thumbnail-url';
import { VideoItemGeneratingThumbnail } from 'components/video-generating/video-generating-thumbnail';
import { VideoPlayerWrapper } from './video-player-wrapper';

const VideoPlayer = ({ playerConfiguration, inlineVideoControls }) => {
  const video = useSelector(getVideoSelector);
  const withRating = useSelector(getRatingFeatureSelector);
  const thumbnailUrl = useThumbnailUrl(video);

  return !thumbnailUrl ? (
    <VideoItemGeneratingThumbnail />
  ) : (
    <div className={`ct-video-player`}>
      <VideoPlayerWrapper playerConfiguration={playerConfiguration} video={video} />
      <VideoInfo video={video} inlineVideoControls={inlineVideoControls} withRating={withRating} />
    </div>
  );
};

VideoPlayer.propTypes = {
  playerConfiguration: PropTypes.object.isRequired,
  inlineVideoControls: PropTypes.func,
};

export const VideoPlayerDecorated = (props) => {
  const video = useSelector(getVideoSelector);
  const loading = get(useSelector(getVideoBoxUISelector), 'loading');

  return loading || !video ? <VideoPlaceholder /> : <VideoPlayer {...props} />;
};

export * from './video-description';
export * from './video-placeholder';
export * from './video-info';
export * from './video-player-embed';
